import {
  Box,
  Paper,
  Skeleton,
  Stack,
  TableHead,
  Typography,
} from "@mui/material";
const rows = [...Array(5)]?.map(() => ({
  skeleton: (
    <Skeleton
      variant="rounded"
      height={90}
      sx={{ backgroundColor: "#EBEBEB" }}
    />
  ),
}));
const InsightDetailsSkeletion = () => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        overflowY: "scroll",
      }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        p={1}
        sx={{
          backgroundColor: "#FFFFFF",
          borderRadius: "3px",
        }}
      >
        <Typography sx={{ fontSize: "16px", fontWeight: "600" }}>
          Insight
        </Typography>
        <Stack direction={"row"} gap={1}>
          <Skeleton
            variant="rounded"
            height={30}
            width={60}
            sx={{ backgroundColor: "#f3f3f3" }}
          />
          <Skeleton
            variant="rounded"
            height={30}
            width={60}
            sx={{ backgroundColor: "#f3f3f3" }}
          />
          <Skeleton
            variant="rounded"
            height={30}
            width={60}
            sx={{ backgroundColor: "#f3f3f3" }}
          />
        </Stack>
      </Stack>
      {rows?.map((row, index) => (
        <Box my={1}>{row.skeleton}</Box>
      ))}
    </Box>
  );
};

export default InsightDetailsSkeletion;
